/**
 * State
 */
export const state = {
  message: "",
  color: "secondary",
  icon: ""
}

/**
 * Getters
 */
export const getters = {
  color: state => state.color,
  icon: state => state.icon,
  message: state => state.message,
}

/**
 * Actions
 */
export const actions = {
  resetNotifier(context) {
    context.commit('NOTIFIER_RESET')
  },
  setError(context, message) {
    let fullMessage = '' + message
    if(message.response && message.response.data && message.response.data.message) {
      fullMessage += '. ' + message.response.data.message
    }
    context.commit('NOTIFIER_SET_ERROR', fullMessage)
  },
  setInfo(context, message) {
    context.commit('NOTIFIER_SET_INFO', message)
  },
  setMessage(context, message) {
    context.commit('NOTIFIER_SET_MESSAGE', message)
  },
  setSuccess(context, message) {
    context.commit('NOTIFIER_SET_SUCCESS', message)
  },
  setWarning(context, message) {
    context.commit('NOTIFIER_SET_WARNING', message)
  },
}

/**
 * Mutations
 */
export const mutations = {
  NOTIFIER_RESET(state) {
    state.message = ""
  },
  NOTIFIER_SET_ERROR(state, message) {
    state.color = "error"
    state.icon = "mdi-bell-ring-outline"
    state.message = message
  },
  NOTIFIER_SET_INFO(state, message) {
    state.color = "info"
    state.icon = "mdi-information-outline"
    state.message = message
  },
  NOTIFIER_SET_MESSAGE(state, message) {
    state.color = "secondary"
    state.icon = "mdi-message"
    state.message = message
  },
  NOTIFIER_SET_SUCCESS(state, message) {
    state.color = "success"
    state.icon = "mdi-check"
    state.message = message
  },
  NOTIFIER_SET_WARNING(state, message) {
    state.color = "warning"
    state.icon = "mdi-bell-outline"
    state.message = message
  }
}

export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
}
